import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    FontSizeBox,
    FontSizeButton,
} from "../../../Components/StyledComponents";
import {TfiMinus, TfiPlus, TfiAlignLeft, TfiAlignRight, TfiAlignCenter, TfiAlignJustify} from "react-icons/tfi";
import Box from '@mui/joy/Box';
import Radio, { radioClasses } from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import IconButton from '@mui/joy/IconButton';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import { MdOutlineStrikethroughS } from "react-icons/md";
import {setPanelKey} from "../../../store/reducers/panleKey";
import {setColorType} from "../../../store/reducers/colorReducer";

const EditTextPanel = () => {
    const {canvas} = useSelector((state) => state.canvas);
    const {activeSetting} = useSelector((state) => state.canvas);
    const {activeObject} = useSelector((state) => state.canvas);

    const dispatch = useDispatch()

    const [fontSize, setFontSize] = useState(0);
    const [colorValue, setColorValue] = useState('#000000');
    const [fontWeight, setFontWeight] = useState('');
    const [fontStyle, setFontStyle] = useState('normal');
    const [underline, setUnderline] = useState(false);
    const [align, setAlign] = useState('');
    const [actScale, setActScale] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [lineThrough, setLineThrough] = useState(false);

    useEffect(() => {
        if (activeSetting) {
            const {
                fontSize,
                fontStyle,
                fontWeight,
                underline,
                textAlignment,
                textColor,
                lineThrough,
                scaleX,
                lineHeight
            } = activeSetting;
            setLineHeight(lineHeight*100)
            setAlign(textAlignment);
            setColorValue(textColor);
            setFontStyle(fontStyle);
            setUnderline(underline);
            setFontWeight(fontWeight);
            setLineThrough(lineThrough);
            setFontSize(fontSize);
            setActScale(scaleX)
        }
    }, [activeSetting, activeObject]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    const changeFontSize = (event) => {
        let val = Number(event.target.value)
        let value = val / activeObject.scaleX
        setFontSize(value);
        setStyle(activeObject, 'fontSize', value)
        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const updateFontSize = (event, mode) => {
        let value = fontSize
        if (isNaN(value)) return;
        if (mode === 'increase') {
            value = value + 1
            if (value > 500) {
                return;
            }
        } else {
            value = value - 1
            if (value < 5) {
                return;
            }
        }
        if (activeObject) {
            setFontSize(value);
            activeObject.set({
                fontSize: value,
            });
            canvas.renderAll();
        }
        canvas.fire('object:modified', {target: activeObject});
    };

    const getStyle = (styleName, object) => {
        object = object || canvas.getActiveObject();
        if (!object) return '';
        return (object.getStyleAtPosition && object.isEditing) ? object.getStyleAtPosition(object.selectionStart)[styleName] : object[styleName];
    };

    const setStyle = (object, styleName, value) => {
        object = object || canvas.getActiveObject();
        if (!object) return;

        if (object.setSelectionStyles && object.isEditing) {
            const style = {};
            style[styleName] = value;
            object.setSelectionStyles(style);
            object.setCoords();
        } else {
            object.set(styleName, value);
        }

        object.setCoords();
        canvas.requestRenderAll();
    };


    const alignText = (type) => {
        if (activeObject) {
            activeObject.set({textAlign: type});
            canvas.renderAll();
            setAlign(type);
        }
        canvas.fire('object:modified', {target: activeObject});
    };

    const lineHeightHandler = (event, mode) => {
        let value = lineHeight
        if (isNaN(value)) return;
        if (mode === 'increase') {
            value = value + 1
        } else {
            value = value - 1
            if (value < 5) {
                return;
            }
        }
        if (activeObject) {
            setLineHeight(value);
            activeObject.set({
                lineHeight: value/100
            })
            // setStyle(activeObject, 'lineHeight', value/100)
            canvas.renderAll();
        }
        canvas.fire('object:modified', {target: activeObject});
    }

    const changeLineHeight = (event) => {
        let value = Number(event.target.value)
        setLineHeight(value);
        setStyle(activeObject, 'lineHeight', value/100)
        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const textProperty = (value) => {
        switch (value) {
            case 'bold':
                if (activeObject.setSelectionStyles && activeObject.isEditing) {
                    if (activeObject._text.length === activeObject.getSelectedText().length) {
                        const {selectionStart} = activeObject;
                        const {selectionEnd} = activeObject;
                        activeObject.exitEditing();
                        setStyle(activeObject, 'fontWeight', getStyle('fontWeight') === 'bold' ? '' : 'bold');
                        activeObject.enterEditing();
                        activeObject.setSelectionStart(selectionStart);
                        activeObject.setSelectionEnd(selectionEnd);
                        setFontWeight(getStyle('fontWeight') === 'bold' ? 'bold' : '');
                    } else {
                        setStyle(activeObject, 'fontWeight', getStyle('fontWeight') === 'bold' ? '' : 'bold');
                        setFontWeight(getStyle('fontWeight') === 'bold' ? 'bold' : '');
                    }
                } else {
                    setStyle(activeObject, 'fontWeight', getStyle('fontWeight') === 'bold' ? '' : 'bold');
                    setFontWeight(getStyle('fontWeight') === 'bold' ? 'bold' : '');
                }
                canvas.fire('object:modified', {target: activeObject});
                break;
            case 'italic':
                if (activeObject.setSelectionStyles && activeObject.isEditing) {
                    if (activeObject._text.length === activeObject.getSelectedText().length) {
                        const {selectionStart} = activeObject;
                        const {selectionEnd} = activeObject;
                        activeObject.exitEditing();
                        setStyle(activeObject, 'fontStyle', getStyle('fontStyle') === 'italic' ? '' : 'italic');
                        activeObject.enterEditing();
                        activeObject.setSelectionStart(selectionStart);
                        activeObject.setSelectionEnd(selectionEnd);
                        setFontStyle(getStyle('fontStyle') === 'italic' ? 'italic' : '');
                    } else {
                        setStyle(activeObject, 'fontStyle', getStyle('fontStyle') === 'italic' ? '' : 'italic');
                        setFontStyle(getStyle('fontStyle') === 'italic' ? 'italic' : '');
                    }
                } else {
                    setStyle(activeObject, 'fontStyle', getStyle('fontStyle') === 'italic' ? '' : 'italic');
                    setFontStyle(getStyle('fontStyle') === 'italic' ? 'italic' : '');
                }
                canvas.fire('object:modified', {target: activeObject});
                break;
            case 'underline':
                if (activeObject.setSelectionStyles && activeObject.isEditing) {
                    if (activeObject._text.length === activeObject.getSelectedText().length) {
                        const {selectionStart} = activeObject;
                        const {selectionEnd} = activeObject;
                        activeObject.exitEditing();
                        setStyle(activeObject, 'underline', !getStyle('underline'));
                        setUnderline(!getStyle('underline'));
                        activeObject.enterEditing();
                        activeObject.setSelectionStart(selectionStart);
                        activeObject.setSelectionEnd(selectionEnd);
                    } else {
                        setStyle(activeObject, 'underline', !getStyle('underline'));
                        setUnderline(!getStyle('underline'));
                    }
                } else {
                    setStyle(activeObject, 'underline', !getStyle('underline'));
                    setUnderline(getStyle('underline'));
                }
                canvas.fire('object:modified', {target: activeObject});
                break;
            case 'linethrough':
                if (activeObject.setSelectionStyles && activeObject.isEditing) {
                    if (activeObject._text.length === activeObject.getSelectedText().length) {
                        const {selectionStart} = activeObject;
                        const {selectionEnd} = activeObject;
                        activeObject.exitEditing();
                        setStyle(activeObject, 'linethrough', !getStyle('linethrough'));
                        setLineThrough(!getStyle('linethrough'));
                        activeObject.enterEditing();
                        activeObject.setSelectionStart(selectionStart);
                        activeObject.setSelectionEnd(selectionEnd);
                    } else {
                        setStyle(activeObject, 'linethrough', !getStyle('linethrough'));
                        setLineThrough(!getStyle('linethrough'));
                    }
                } else {
                    setStyle(activeObject, 'linethrough', !getStyle('linethrough'));
                    setLineThrough(getStyle('linethrough'));
                }
                canvas.fire('object:modified', {target: activeObject});
                break;
            default:
                return;
        }
        canvas.renderAll();
    };

    return (
        <div className="text-panel-wrapper">
            <div style={{paddingTop:0}} className='text-header'>
                <span className="heading-text">Edit Text</span>
            </div>
            <ul className="text-props-icons list-group">
                <li className="list-group-item">
                    <span className="body-xs-bold color-primary  ">Color</span>
                    <span onClick={() => {
                        dispatch(setPanelKey('colorPicker'))
                        dispatch(setColorType('text'))
                    }} className="color-preview" style={{background: `${colorValue}`}}></span>
                </li>
                <li className="list-group-item">
                    <span className="body-xs-bold color-primary  ">Style</span>
                    <Box sx={{display:'flex', gap:'2px'}}>
                        <IconButton  sx={{backgroundColor:`${fontWeight === 'bold' ? '#ebf2ff' : ''}`}} onClick={()=>textProperty('bold')}>
                            <FormatBoldIcon />
                        </IconButton>
                        <IconButton sx={{backgroundColor:`${fontStyle === 'italic' ? '#ebf2ff' : ''}`}} onClick={()=>textProperty('italic')}>
                            <FormatItalicIcon />
                        </IconButton>
                        <IconButton sx={{backgroundColor:`${underline ? '#ebf2ff' : ''}`}} onClick={()=>textProperty('underline')}>
                            <FormatUnderlinedIcon />
                        </IconButton>
                        <IconButton sx={{backgroundColor:`${lineThrough ? '#ebf2ff' : ''}`}} onClick={()=>textProperty('linethrough')}>
                            <MdOutlineStrikethroughS size={25}/>
                        </IconButton>
                    </Box>
                </li>
                <li className="list-group-item">
                    <span>Size</span>
                    <FontSizeBox>
                        <FontSizeButton onClick={(e) => {
                            updateFontSize(e, 'decrease')
                        }}>
                            <TfiMinus size={15} color='black'/>
                        </FontSizeButton>
                        <input className="font-input" type={'number'}
                               value={Math.round(fontSize * actScale)} onChange={changeFontSize}/>
                        <FontSizeButton onClick={(e) => {
                            updateFontSize(e, 'increase')
                        }}>
                            <TfiPlus size={15} color='black'/>
                        </FontSizeButton>
                    </FontSizeBox>
                </li>
                <li className="list-group-item">
                    <span className="body-xs-bold color-primary  ">Alignment</span>
                    <RadioGroup
                        orientation="horizontal"
                        aria-label="Alignment"
                        name="alignment"
                        variant="outlined"
                        value={align}
                        size="sm"
                        color={'neutral'}
                        onChange={(event) => alignText(event.target.value)}
                    >
                        {['left', 'center', 'right', 'justify'].map((item) => (
                            <Box
                                key={item}
                                size="sm"
                                sx={(theme) => ({
                                    position: 'relative',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: 32,
                                    height: 32,
                                    '&:not([data-first-child])': {
                                        borderLeft: '1px solid',
                                        borderColor: 'divider',
                                    },
                                    [`&[data-first-child] .${radioClasses.action}`]: {
                                        borderTopLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                                        borderBottomLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                                    },
                                    [`&[data-last-child] .${radioClasses.action}`]: {
                                        borderTopRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                                        borderBottomRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
                                    },
                                })}
                            >
                                <Radio
                                    value={item}
                                    disableIcon
                                    overlay
                                    size="sm"
                                    label={
                                        {
                                            left: <TfiAlignLeft height={'20'}/>,
                                            right: <TfiAlignRight height={'20'} />,
                                            center: <TfiAlignCenter height={'20'} />,
                                            justify: <TfiAlignJustify height={'20'} />,
                                        }[item]
                                    }
                                    variant={align === item ? 'solid' : 'plain'}
                                    slotProps={{
                                        input: { 'aria-label': item },
                                        action: {
                                            sx: { borderRadius: 0, transition: 'none' },
                                        },
                                        label: { sx: { lineHeight: 0 } },
                                    }}
                                />
                            </Box>
                        ))}
                    </RadioGroup>
                </li>

                <li className="list-group-item">
                    <span className="body-xs-bold color-primary  ">Line height</span>
                    <FontSizeBox>
                        <FontSizeButton onClick={(e) => {lineHeightHandler(e, 'decrease')}}>
                            <TfiMinus size={15} color='black'/>
                        </FontSizeButton>
                        <input className="font-input" type={'number'}
                               value={lineHeight.toFixed(0)} onChange={changeLineHeight}/>
                        <FontSizeButton onClick={(e) => {
                            lineHeightHandler(e, 'increase')
                        }}>
                            <TfiPlus size={15} color='black'/>
                        </FontSizeButton>
                    </FontSizeBox>
                </li>
            </ul>
        </div>
    );
};

export default EditTextPanel;